const STORAGE_KEY = "4demr_impersonation";
const ACCOUNTS_CACHE_KEY = "4demr_accounts_cache";

export type ImpersonationUiState = {
  impersonation_id: string;
  target_email: string;
  target_user_id: string;
  expires_at: string;
};

export type CachedAccount = {
  user_id: string;
  email: string | null;
  last_sign_in_at?: string | null;
  facilities?: Array<{
    type: string;
    facility_name: string | null;
    location_id: string | null;
    status: string;
  }>;
};

export function loadImpersonation(): ImpersonationUiState | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ImpersonationUiState;
    if (!parsed?.impersonation_id || !parsed?.expires_at) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveImpersonation(state: ImpersonationUiState): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

export function clearImpersonation(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function isImpersonationExpired(state: ImpersonationUiState | null): boolean {
  if (!state?.expires_at) return true;
  return new Date(state.expires_at).getTime() <= Date.now();
}

/** Cache tenant list so switcher works while impersonating (target JWT is not superadmin). */
export function saveAccountsCache(accounts: CachedAccount[]): void {
  try {
    sessionStorage.setItem(
      ACCOUNTS_CACHE_KEY,
      JSON.stringify({ at: Date.now(), accounts })
    );
  } catch {
    /* ignore quota */
  }
}

export function loadAccountsCache(): CachedAccount[] {
  try {
    const raw = sessionStorage.getItem(ACCOUNTS_CACHE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as { accounts?: CachedAccount[] };
    return Array.isArray(parsed.accounts) ? parsed.accounts : [];
  } catch {
    return [];
  }
}

export function clearAccountsCache(): void {
  sessionStorage.removeItem(ACCOUNTS_CACHE_KEY);
}
